import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EFormService } from '../../../../shared-components/e-forms/e-form.service';
import { EFormInstance } from '../../../../shared-components/e-forms/e-form-instance.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { EFormTemplate } from '../../../../shared-components/e-forms/e-form-template.model';

@AutoUnsubscribe({includeArrays: true})
@Component({
  selector: 'app-e-form-template-in-use-warning',
  templateUrl: './e-form-template-in-use-warning.component.html',
  styleUrls: ['./e-form-template-in-use-warning.component.css']
})
export class EFormTemplateInUseWarningComponent implements OnInit, OnDestroy {

  template: EFormTemplate;
  instances: EFormInstance[] = [];
  subscriptions: Subscription[] = [];
  constructor(
    private dialogRef: MatDialogRef<EFormTemplateInUseWarningComponent>,
    private eFormService: EFormService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.template = data.template;
  }

  ngOnInit() {
    this.getInstances();
  }

  ngOnDestroy() {}

  getInstances() {
    if (this.template) {
      this.subscriptions.push(this.eFormService.getInstancesByTemplateId(this.template.ID).subscribe(instances => {
        this.instances = instances;
      }));
    }
  }

  continueClick() {
    this.dialogRef.close(true);
  }

  cancelClick() {
    this.dialogRef.close(false);
  }

}
